import { FC } from 'react';

import { ButtonsContainer, Container, FooterButton } from './styled';

export type Props = {
  primaryButton: string;
  secondaryButton?: string;
  onClickPrimary: () => void;
  onClickSecondary?: () => void;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
};

const FooterButtons: FC<Props> = ({
    onClickPrimary,
    primaryButton,
    onClickSecondary,
    primaryDisabled,
    secondaryButton,
    secondaryDisabled
}: Props) => {
    return (
        <Container>
            <ButtonsContainer>
                {primaryButton && <FooterButton onClick={onClickPrimary} disabled={primaryDisabled}>
                    {primaryButton}
                </FooterButton>}
                {secondaryButton && onClickSecondary ? (
                    <FooterButton onClick={onClickSecondary} disabled={secondaryDisabled}>
                        {secondaryButton}
                    </FooterButton>
                ) : null}
            </ButtonsContainer>
        </Container>
    );
};

export default FooterButtons;
